import axios from "axios";

export default {
  getBanner: (place) => {
    return axios.get("/w1/banner", { params: { place: place } });
  },
};
